(function(){
  if (!document.querySelector('[data-ef-filters-v5]') || window.__efCollectionFilterValuesV5) return;
  window.__efCollectionFilterValuesV5 = true;
  document.addEventListener('click', function(e){
    var a = e.target.closest('.m6pn .ef-panel-sort .bv_ul_inner a.option');
    if (!a) return;
    var li = a.closest('.li');
    if (li && (li.classList.contains('bv_disabled') || li.classList.contains('nofocus') || li.classList.contains('bv_separator'))) return;
    var ul = a.closest('.bv_ul_inner');
    if (!ul) return;
    var allOptions = ul.querySelectorAll('a.option');
    var optionIndex = Array.from(allOptions).indexOf(a);
    if (optionIndex < 0) return;
    var sb = document.getElementById('sort_by_panel');
    if (!sb || !sb.options[optionIndex]) return;
    var v = sb.options[optionIndex].value;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', v);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  function efRangeGetValues(slider){
    return Array.from(slider.querySelectorAll('.ef-range-data li')).map(function(li){
      return { value: li.getAttribute('data-value'), label: li.getAttribute('data-label') };
    });
  }
  function efRangeUpdateUI(slider){
    var values = efRangeGetValues(slider);
    if (values.length < 2) return;
    var minInput = slider.querySelector('.ef-range-min');
    var maxInput = slider.querySelector('.ef-range-max');
    var boundMin = slider.querySelector('.ef-range-bound-min');
    var boundMax = slider.querySelector('.ef-range-bound-max');
    var fill = slider.querySelector('.ef-range-fill');
    var maxIdx = values.length - 1;
    var minV = parseInt(minInput.value, 10);
    var maxV = parseInt(maxInput.value, 10);
    if (minV > maxV){ var tmp = minV; minV = maxV; maxV = tmp; minInput.value = minV; maxInput.value = maxV; }
    if (boundMin && values[minV]) boundMin.textContent = values[minV].label;
    if (boundMax && values[maxV]) boundMax.textContent = values[maxV].label;
    if (values[minV]) minInput.setAttribute('aria-valuetext', values[minV].label.replace(/\s*K$/i, ' ' + (slider.dataset.efKelvinLabel || 'K')));
    if (values[maxV]) maxInput.setAttribute('aria-valuetext', values[maxV].label.replace(/\s*K$/i, ' ' + (slider.dataset.efKelvinLabel || 'K')));
    if (fill && maxIdx > 0){
      fill.style.left = (minV / maxIdx * 100) + '%';
      fill.style.width = ((maxV - minV) / maxIdx * 100) + '%';
    }
  }
  function efRangeSubmit(slider){
    var values = efRangeGetValues(slider);
    if (values.length < 2) return;
    var minInput = slider.querySelector('.ef-range-min');
    var maxInput = slider.querySelector('.ef-range-max');
    var param = slider.getAttribute('data-param');
    if (!param) return;
    var minV = parseInt(minInput.value, 10);
    var maxV = parseInt(maxInput.value, 10);
    if (minV > maxV){ var tmp = minV; minV = maxV; maxV = tmp; }
    var u = new URL(window.location.href);
    u.searchParams.delete(param);
    for (var i = minV; i <= maxV; i++){
      u.searchParams.append(param, values[i].value);
    }
    u.searchParams.delete('page');
    window.location.href = u.toString();
  }
  document.addEventListener('input', function(e){
    var input = e.target;
    if (!input || !input.matches || !input.matches('.ef-range-slider input[type="range"]')) return;
    var slider = input.closest('.ef-range-slider');
    if (slider) efRangeUpdateUI(slider);
  }, true);
  document.addEventListener('change', function(e){
    var input = e.target;
    if (!input || !input.matches || !input.matches('.ef-range-slider input[type="range"]')) return;
    e.stopPropagation();
    var slider = input.closest('.ef-range-slider');
    if (slider) efRangeSubmit(slider);
  }, true);

  document.addEventListener('change', function(e){
    var cb = e.target;
    if (!cb || !cb.matches || !cb.matches('.ef-temp-mode')) return;
    e.stopPropagation();
    var container = cb.closest('.ef-temp-mode-toggles');
    if (!container) return;
    if (!cb.checked) {
      var anyOther = Array.from(container.querySelectorAll('.ef-temp-mode')).some(function(other){
        return other !== cb && other.checked;
      });
      if (!anyOther) { cb.checked = true; return; }
    }
    var slider = container.nextElementSibling;
    while (slider && !slider.classList.contains('ef-range-slider')) {
      slider = slider.nextElementSibling;
    }
    if (!slider) return;
    Array.from(container.querySelectorAll('.ef-temp-mode')).forEach(function(other){
      if (other !== cb && cb.checked) other.checked = false;
    });
    if (cb.dataset.mode === 'led' && cb.checked) {
      slider.hidden = false;
    } else {
      slider.hidden = true;
      if (cb.dataset.mode === 'default' && cb.checked) {
        var param = container.getAttribute('data-temp-param');
        if (param) {
          var u = new URL(window.location.href);
          if (u.searchParams.has(param)) {
            u.searchParams.delete(param);
            u.searchParams.delete('page');
            window.location.href = u.toString();
          }
        }
      }
    }
  }, true);

  document.addEventListener('click', function(e){
    var chip = e.target.closest('a.ef-chip[data-clear-param]');
    if (!chip) return;
    e.preventDefault();
    var param = chip.getAttribute('data-clear-param');
    if (!param) return;
    var u = new URL(window.location.href);
    u.searchParams.delete(param);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });
})();

(function () {
  'use strict';
  if (!document.querySelector('[data-ef-filters-v5]') || window.__efCollectionFilterModalV5) return;
  window.__efCollectionFilterModalV5 = true;
  var root = document.getElementById('root');
  var panel = null;
  var panelObserver = null;
  var opened = false;
  var trigger = null;
  var remembered = null;
  var pending = null;
  var failedControl = null;
  var retryFocus = null;
  var pendingScroll = 0;
  var inerted = new Map();
  var overflow = '';
  var overflowPriority = '';
  var scheduled = false;
  var focusing = false;
  var nativeControls = 'a[href],button,input:not([type="hidden"]),select,textarea,[role="button"],[role="slider"]';

  function setAttribute(el, name, value) {
    if (el && el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  function visible(el) {
    if (!el || !el.isConnected || !el.getClientRects().length || el.closest('[hidden],[inert]')) return false;
    var style = getComputedStyle(el);
    return style.visibility !== 'hidden' && style.display !== 'none' && style.opacity !== '0';
  }

  function isOpen() {
    return !!panel && panel.isConnected && panel.getAttribute('aria-hidden') === 'false';
  }

  function describe(el) {
    if (!el || !panel || !panel.contains(el)) return null;
    var heading = el.closest('h4[data-filter-toggle]');
    return {
      id: el.id,
      name: el.name,
      value: el.value,
      type: el.type,
      mode: el.dataset && el.dataset.mode,
      range: el.classList.contains('ef-range-min') ? 'ef-range-min' : el.classList.contains('ef-range-max') ? 'ef-range-max' : '',
      priceHandle: el.matches('.input-range [role="slider"]') ? Array.from(el.closest('.input-range').querySelectorAll('[role="slider"]')).indexOf(el) : -1,
      heading: heading && heading.dataset.filterToggle,
      close: el.classList.contains('m6pn-close')
    };
  }

  function findControl(record) {
    if (!record || !panel) return null;
    var controls = Array.from(panel.querySelectorAll(nativeControls));
    if (record.priceHandle >= 0) return panel.querySelectorAll('.input-range [role="slider"]')[record.priceHandle] || null;
    return controls.find(function (el) {
      if (record.range) return el.classList.contains(record.range);
      if (record.mode) return el.dataset.mode === record.mode;
      if (record.heading) return el.closest('h4[data-filter-toggle]') && el.closest('h4[data-filter-toggle]').dataset.filterToggle === record.heading;
      if (record.close) return el.classList.contains('m6pn-close');
      if (record.id && el.id === record.id) return true;
      return record.name && el.name === record.name && el.type === record.type && (el.type !== 'checkbox' || el.value === record.value);
    }) || null;
  }

  function focusInside(preferred, tries) {
    if (!isOpen()) return;
    var candidate = visible(preferred) ? preferred : panel.querySelector('.m6pn-close');
    if (!visible(candidate)) candidate = panel;
    if (visible(candidate)) {
      focusing = true;
      candidate.focus({ preventScroll: true });
      focusing = false;
      if (panel.contains(document.activeElement)) return;
    }
    if ((tries || 0) < 60) requestAnimationFrame(function () { focusInside(preferred, (tries || 0) + 1); });
  }

  function releaseBackground() {
    inerted.forEach(function (value, el) {
      if (value === null) el.removeAttribute('inert');
      else el.setAttribute('inert', value);
    });
    inerted.clear();
  }

  function containBackground() {
    releaseBackground();
    var child = panel;
    while (child && child.parentElement) {
      var parent = child.parentElement;
      Array.from(parent.children).forEach(function (sibling) {
        if (sibling === child || /^(SCRIPT|STYLE|LINK|META)$/.test(sibling.tagName)) return;
        inerted.set(sibling, sibling.getAttribute('inert'));
        sibling.setAttribute('inert', '');
      });
      if (parent === document.body) break;
      child = parent;
    }
  }

  function repairSemantics() {
    if (!panel) return;
    if (!panel.classList.contains('ef-v5-filter-panel')) panel.classList.add('ef-v5-filter-panel');
    setAttribute(panel, 'role', 'dialog');
    setAttribute(panel, 'aria-modal', 'true');
    setAttribute(panel, 'tabindex', '-1');
    var heading = panel.querySelector('.ef-facets-title');
    if (heading) {
      if (!heading.id) heading.id = 'ef-v5-filters-title';
      setAttribute(panel, 'aria-labelledby', heading.id);
    }
    var form = panel.querySelector('[data-ef-filters-v5]');
    var close = panel.querySelector('.m6pn-close');
    if (close && form) setAttribute(close, 'aria-label', form.dataset.efCloseLabel);
    panel.querySelectorAll('h4[data-filter-toggle]').forEach(function (title) {
      var toggle = title.querySelector('.header-toggle');
      var label = title.querySelector('.ef-h4-text');
      if (toggle && label) {
        setAttribute(toggle, 'aria-label', label.textContent.trim());
        setAttribute(toggle, 'aria-expanded', title.classList.contains('toggle') ? 'true' : 'false');
      }
    });
    panel.querySelectorAll('.ef-range-slider').forEach(function (slider) {
      var labels = Array.from(slider.querySelectorAll('.ef-range-data li'));
      slider.querySelectorAll('input[type="range"]').forEach(function (input) {
        var item = labels[Number(input.value)];
        if (item) setAttribute(input, 'aria-valuetext', item.dataset.label.replace(/\s*K$/i, ' ' + (slider.dataset.efKelvinLabel || 'K')));
      });
    });
    panel.querySelectorAll('.input-range').forEach(function (range) {
      var priceInputs = [range.querySelector('#min'), range.querySelector('#max')];
      range.querySelectorAll('[role="slider"]').forEach(function (handle, index) {
        if (priceInputs[index]) setAttribute(handle, 'aria-label', priceInputs[index].getAttribute('aria-label'));
      });
    });
    if (isOpen()) {
      panel.querySelectorAll(nativeControls).forEach(function (el) {
        if (el.getAttribute('tabindex') === '-1') el.removeAttribute('tabindex');
      });
    }
  }

  function returnFocus() {
    var current = visible(trigger) ? trigger : Array.from(document.querySelectorAll('[data-panel="filters"]')).find(visible);
    if (current) current.focus({ preventScroll: true });
    trigger = null;
  }

  function synchronize() {
    scheduled = false;
    var nextPanel = document.getElementById('filters');
    var replaced = nextPanel !== panel;
    if (replaced) {
      if (panelObserver) panelObserver.disconnect();
      panel = nextPanel;
      if (panel) {
        panelObserver = new MutationObserver(schedule);
        panelObserver.observe(panel, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden', 'class', 'tabindex'] });
      }
    }
    var open = isOpen();
    document.querySelectorAll('[data-panel="filters"]').forEach(function (el) {
      setAttribute(el, 'aria-haspopup', 'dialog');
      setAttribute(el, 'aria-controls', 'filters');
      setAttribute(el, 'aria-expanded', open ? 'true' : 'false');
    });
    repairSemantics();
    if (open && !opened) {
      overflow = document.body.style.getPropertyValue('overflow');
      overflowPriority = document.body.style.getPropertyPriority('overflow');
      document.body.style.setProperty('overflow', 'hidden');
      containBackground();
      opened = true;
      document.querySelectorAll('a.m6pn-clicked:not([data-panel="filters"])').forEach(function (el) { el.classList.remove('m6pn-clicked'); });
      focusInside(findControl(pending), 0);
    } else if (open && replaced) {
      containBackground();
      focusInside(findControl(pending || remembered), 0);
      panel.scrollTop = pendingScroll;
    } else if (!open && opened && !pending) {
      opened = false;
      releaseBackground();
      if (!document.querySelector('.m6pn[aria-hidden="false"]')) {
        if (overflow) document.body.style.setProperty('overflow', overflow, overflowPriority);
        else document.body.style.removeProperty('overflow');
        returnFocus();
      }
      remembered = null;
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(synchronize);
  }

  function filterError() {
    return document.getElementById('ef-v5-filter-error');
  }

  function clearFilterError() {
    var notice = filterError();
    if (notice) notice.remove();
    failedControl = null;
    retryFocus = null;
  }

  function showFilterError() {
    failedControl = pending || remembered || failedControl;
    pending = null;
    retryFocus = null;
    synchronize();
    var form = document.querySelector('[data-ef-filters-v5]');
    if (!form) return;
    form.classList.remove('processing');
    form.removeAttribute('aria-busy');
    form.querySelectorAll('.link-btn .submit.loading').forEach(function (el) { el.classList.remove('loading'); });
    var section = document.getElementById('shopify-section-' + form.dataset.template);
    if (section) section.querySelectorAll('.l4cl.processing').forEach(function (el) { el.classList.remove('processing'); });
    var notice = filterError();
    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'ef-v5-filter-error';
      notice.className = 'ef-v5-filter-error';
      notice.setAttribute('role', 'alert');
      var message = document.createElement('p');
      message.textContent = 'Les filtres n’ont pas pu être appliqués. Réessayez.';
      var retry = document.createElement('button');
      retry.type = 'button';
      retry.id = 'ef-v5-filter-retry';
      retry.setAttribute('data-ef-filter-retry', '');
      retry.textContent = 'Réessayer';
      notice.append(message, retry);
    }
    notice.removeAttribute('aria-busy');
    notice.querySelector('[data-ef-filter-retry]').disabled = false;
    var destination = isOpen() ? form.querySelector('footer') || form : section && (section.querySelector('.f8sr') || section);
    if (destination && notice.parentElement !== destination) destination.prepend(notice);
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var retry = event.target.closest('[data-ef-filter-retry]');
    if (retry) {
      event.preventDefault();
      if (retry.disabled) return;
      retryFocus = failedControl;
      retry.disabled = true;
      if (typeof window.processFilters === 'function') {
        try { window.processFilters(); }
        catch (error) { showFilterError(); }
      } else {
        showFilterError();
      }
      return;
    }
    var openTrigger = event.target.closest('[data-panel="filters"]');
    if (openTrigger) {
      event.preventDefault();
      trigger = openTrigger;
      remembered = null;
      pending = null;
      schedule();
    }
    if (panel && panel.contains(event.target) && event.target.closest('.m6pn-close,[data-panel-hide="filters"]')) {
      event.preventDefault();
      pending = null;
    }
  }, true);

  document.addEventListener('focusin', function (event) {
    if (!isOpen() || focusing) return;
    if (panel.contains(event.target)) remembered = describe(event.target);
    else focusInside(findControl(remembered), 0);
  }, true);

  document.addEventListener('change', function (event) {
    if (isOpen() && panel.contains(event.target)) remembered = describe(event.target);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (!isOpen()) return;
    if (event.key === 'Escape') {
      var expandedSelect = panel.querySelector('.bv_mainselect .bv_ul_inner:not([aria-hidden="true"])');
      if (expandedSelect && visible(expandedSelect)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      pending = null;
      var close = panel.querySelector('.m6pn-close');
      if (close) close.click();
      return;
    }
    if (event.key !== 'Tab') return;
    var items = Array.from(panel.querySelectorAll(nativeControls + ',[tabindex]')).filter(function (el) {
      return !el.disabled && el.tabIndex >= 0 && visible(el);
    });
    if (!items.length) {
      event.preventDefault();
      panel.focus({ preventScroll: true });
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    if (!panel.contains(document.activeElement) || (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) || (!event.shiftKey && document.activeElement === last)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus({ preventScroll: true });
    }
  }, true);

  document.addEventListener('ef:collection-filter-before', function () {
    var notice = filterError();
    if (notice) {
      notice.setAttribute('aria-busy', 'true');
      notice.querySelector('[data-ef-filter-retry]').disabled = true;
    }
    if (!isOpen()) return;
    pending = retryFocus || describe(document.activeElement) || remembered;
    retryFocus = null;
    pendingScroll = panel.scrollTop;
  });

  document.addEventListener('ef:collection-filter-after', function () {
    synchronize();
    if (isOpen() && pending) {
      focusInside(findControl(pending), 0);
      panel.scrollTop = pendingScroll;
    }
    pending = null;
    clearFilterError();
    if (!isOpen()) {
      synchronize();
      if (document.activeElement === document.body) returnFocus();
    }
  });

  document.addEventListener('ef:collection-filter-error', showFilterError);

  if (root) new MutationObserver(schedule).observe(root, { childList: true });
  new MutationObserver(schedule).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  synchronize();
})();
